import React from "react";
import { Button } from "antd";
import {
  DownloadOutlined,
  SaveOutlined,
  LeftOutlined,
  RightOutlined,
} from "@ant-design/icons";

const DrawingFooter = ({
  pageIndex,
  numPages,
  windowWidth,
  onPreviousPage,
  onNextPage,
  onDownloadWithAnnotations,
  onDownloadWithoutAnnotations,
  onSave,
  onClose,
  onClearAnnotations,
  canClearAnnotations = true,
  saving = false,
  detectingSheetLinks = false,
}) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: windowWidth < 768 ? "column" : "row",
        alignItems: "center",
        gap: windowWidth < 768 ? 12 : 12,
        justifyContent: "space-between",
        width: "100%",
        padding: windowWidth < 768 ? "12px 8px" : "8px 0",
        borderTop: "1px solid #eee",
        background: "#fafbfc",
      }}
    >
      {windowWidth < 768 ? (
        <>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Button
              key="clear"
              danger
              onClick={onClearAnnotations}
              disabled={!canClearAnnotations}
              title={
                canClearAnnotations
                  ? undefined
                  : "Consultants cannot delete saved annotations"
              }
              style={{
                borderRadius: 6,
                fontWeight: 500,
                flexShrink: 0,
              }}
            >
              Clear All
            </Button>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
              }}
            >
              <Button
                icon={<LeftOutlined />}
                onClick={onPreviousPage}
                disabled={pageIndex === 0}
                style={{ borderRadius: 6, boxShadow: "none" }}
              />
              <span style={{ fontWeight: 500, fontSize: 16 }}>
                {pageIndex + 1} / {numPages}
              </span>
              <Button
                icon={<RightOutlined />}
                onClick={onNextPage}
                disabled={pageIndex === numPages - 1}
                style={{ borderRadius: 6, boxShadow: "none" }}
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              gap: 8,
              flexWrap: "wrap",
              width: "100%",
            }}
          >
            <Button
              key="download-with"
              icon={<DownloadOutlined />}
              type="primary"
              onClick={onDownloadWithAnnotations}
              style={{
                borderRadius: 6,
                fontWeight: 500,
                flex: "1 1 auto",
                minWidth: 0,
              }}
            >
              Download with Annotations
            </Button>
            <Button
              key="download-without"
              icon={<DownloadOutlined />}
              onClick={onDownloadWithoutAnnotations}
              style={{
                borderRadius: 6,
                fontWeight: 500,
                flex: "1 1 auto",
                minWidth: 0,
              }}
            >
              Download Original
            </Button>
            <Button
              key="save"
              icon={<SaveOutlined />}
              type="primary"
              onClick={onSave}
              loading={saving}
              disabled={detectingSheetLinks}
              title={detectingSheetLinks ? "Detecting sheet links..." : undefined}
              style={{
                borderRadius: 6,
                fontWeight: 500,
                flex: "1 1 auto",
                minWidth: 0,
              }}
            >
              Save
            </Button>
            <Button
              key="close"
              onClick={onClose}
              style={{
                borderRadius: 6,
                fontWeight: 500,
                flex: "1 1 auto",
                minWidth: 0,
              }}
            >
              Close
            </Button>
          </div>
        </>
      ) : (
        <>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}
          >
            <Button
              key="clear"
              danger
              onClick={onClearAnnotations}
              disabled={!canClearAnnotations}
              title={
                canClearAnnotations
                  ? undefined
                  : "Consultants cannot delete saved annotations"
              }
              style={{
                borderRadius: 6,
                fontWeight: 500,
                flexShrink: 0,
              }}
            >
              Clear All
            </Button>
            <Button
              icon={<LeftOutlined />}
              onClick={onPreviousPage}
              disabled={pageIndex === 0}
              style={{ borderRadius: 6, boxShadow: "none" }}
            />
            <span style={{ fontWeight: 500, fontSize: 16 }}>
              {pageIndex + 1} / {numPages}
            </span>
            <Button
              icon={<RightOutlined />}
              onClick={onNextPage}
              disabled={pageIndex === numPages - 1}
              style={{ borderRadius: 6, boxShadow: "none" }}
            />
          </div>

          <div
            style={{
              display: "flex",
              gap: 10,
              flexWrap: "wrap",
              justifyContent: "flex-end",
              flex: "1 1 auto",
              minWidth: 0,
            }}
          >
            <Button
              key="download-with"
              icon={<DownloadOutlined />}
              type="primary"
              onClick={onDownloadWithAnnotations}
              style={{
                borderRadius: 6,
                fontWeight: 500,
                flexShrink: 0,
                whiteSpace: "nowrap",
              }}
            >
              Download with Annotations
            </Button>
            <Button
              key="download-without"
              icon={<DownloadOutlined />}
              onClick={onDownloadWithoutAnnotations}
              style={{
                borderRadius: 6,
                fontWeight: 500,
                flexShrink: 0,
                whiteSpace: "nowrap",
              }}
            >
              Download Original
            </Button>
            <Button
              key="save"
              icon={<SaveOutlined />}
              type="primary"
              onClick={onSave}
              loading={saving}
              disabled={detectingSheetLinks}
              title={detectingSheetLinks ? "Detecting sheet links..." : undefined}
              style={{
                borderRadius: 6,
                fontWeight: 500,
                flexShrink: 0,
              }}
            >
              Save
            </Button>
            <Button
              key="close"
              onClick={onClose}
              style={{
                borderRadius: 6,
                fontWeight: 500,
                flexShrink: 0,
              }}
            >
              Close
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default DrawingFooter;

